import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { changeLayout, changeTopbarTheme, changeLayoutWidth, showRightSidebarAction, isUserValid } from "store/actions";
import { useSelector, useDispatch } from "react-redux";
import Navbar from "./Navbar";
import NavbarForStaff from "./NavbarForStaff";
import Header from "./Header";
import RightSidebar from "../CommonForBoth/RightSidebar";
import { me } from "constants/Client";
import { ADMIN_MANAGER_APIS, ROLES } from "common/ComponentAccess";
// import IdleTimer from 'common/IdleTimer';
import { useHistory } from "react-router-dom";

const Layout = props => {
  const [isAuth, setIsAuth] = useState();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    try {
      const obj = me();
      setIsAuth(obj);
    } catch (er) {
      console.log(er);
    }
  }, []);

  const { topbarTheme, layoutWidth, isPreloader, showRightSidebar } = useSelector(state => ({
    topbarTheme: state.Layout.topbarTheme,
    layoutWidth: state.Layout.layoutWidth,
    isPreloader: state.Layout.isPreloader,
    showRightSidebar: state.Layout.showRightSidebar,
  }));

  useEffect(() => {
    const title = props.location.pathname;
    let currentage = title.charAt(1).toUpperCase() + title.slice(2);

    document.title = currentage + "";
  }, [props.location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (ADMIN_MANAGER_APIS()) {
      dispatch(isUserValid({}, history));
    }
  }, []);

  //hides right sidebar on body click
  const hideRightbar = event => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout settings
  */
  useEffect(() => {
    dispatch(changeLayout("horizontal"));
  }, [dispatch]);

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);

    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 1000);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  }, [isPreloader]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [dispatch, topbarTheme]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [dispatch, layoutWidth]);

  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  return (
    <React.Fragment>
      <div id='preloader'>
        <div id='status'>
          <div className='spinner-chase'>
            <div className='chase-dot' />
            <div className='chase-dot' />
            <div className='chase-dot' />
            <div className='chase-dot' />
            <div className='chase-dot' />
            <div className='chase-dot' />
          </div>
        </div>
      </div>

      <div id='layout-wrapper'>
        <Header theme={topbarTheme} isMenuOpened={isMenuOpened} openLeftMenuCallBack={openMenu} />
        {isAuth && [ROLES.ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT].includes(isAuth.role) && <Navbar menuOpen={isMenuOpened} closeMenu={openMenu} />}
        {isAuth && isAuth.role === "staff" && <NavbarForStaff menuOpen={isMenuOpened} closeMenu={openMenu} />}
        <div className='main-content'>{props.children}</div>
        {/* <Footer /> */}
      </div>
      {/* {me().role === ROLES.MANAGER && <IdleTimer />} */}
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayout: PropTypes.func,
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
